<template>
  <div>
    <b-row>
      <b-col sm="4"> 
        <b-form-group label-for="spkb_a" label="SPKB A">
            <vue-autosuggest
                v-model="paymentSpkb.spkb_a"
                @inputout="focusMe"
                :suggestions="filteredOptions"
                @input="onInputChange"
                @selected="onSelected"
                :input-props="{ id: 'spkb_a', placeholder: 'Find SPKB', class: 'form-control'}"
                :limit="20"
            >
                <template slot-scope="{ suggestion }">
                    <span class="my-suggestion-item"> 
                        {{ suggestion.item.text }}
                    </span>
                </template>
            </vue-autosuggest>

        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label-for="spkb_b" label="SPKB B">
                <b-form-input
                  id="spkb_b"
                  type="text"
                  v-model="paymentSpkb.spkb_b"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Contract Number harus di isi.</b-form-invalid-feedback
                >
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label-for="spkb_c" label="SPKB C">
                <b-form-input
                  id="spkb_c"
                  type="text"
                  v-model="paymentSpkb.spkb_c"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Contract Number harus di isi.</b-form-invalid-feedback
                >
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="4"> 
        <b-form-group label-for="amount_spkb_a" label="Amount SPKB A">
                <b-form-input
                  id="amount_spkb_a"
                  type="text"
                  v-model="paymentSpkb.amount_spkb_a"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Contract Number harus di isi.</b-form-invalid-feedback
                >
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label-for="amount_spkb_b" label="Amount SPKB B">
                <b-form-input
                  id="amount_spkb_b"
                  type="text"
                  v-model="paymentSpkb.amount_spkb_b"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Contract Number harus di isi.</b-form-invalid-feedback
                >
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label-for="amount_spkb_c" label="Amount SPKB C">
                <b-form-input
                  id="amount_spkb_c"
                  type="text"
                  v-model="paymentSpkb.amount_spkb_c"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Contract Number harus di isi.</b-form-invalid-feedback
                >
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  name: "payment-spkb",
  components: { globalTable, ModelSelect, MultiSelect, loading, VueAutosuggest },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
    customer: {
      type: [Array, Object],
      default: () => {},
    },
    customerAsset: {
      type: [Array],
      default: () => [],
    },
    listAssetOwner: {
      type: [Array],
      default: () => [],
    },
    listStatusCustomerAsset: {
      type: [Array],
      default: () => [],
    },
    listEmployee: {
      type: [Array],
      default: () => [],
    },
    listAssetStatus: {
      type: [Array],
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    childAddButton: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    customerAssetForm: {
      asset_id: { required },
      contract_number: {},
      asset_owner_id: { required },
      placement_date: { required },
      asset_status: { required },
      assign_send_to: { required },
      assign_spv_operational: { required },
      description_send: { required },
    },
    customerAssetRemoveForm: {
      reason: { required },
    },
  },
  data() {
    return {
      myCustomer: {},
      myLoading: false,
      loadingSubmit: false,
      listAsset: [],
      filteredOptions: [],
      paymentSpkb: {
        spkb_a: {value: null, text: null},
        spkb_b: {value: null, text: null},
        spkb_c: {value: null, text: null}
      },
      
      suggestions: [
        {
          data: [],
        },
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {},
    reload(cust_id) {
      this.$emit("reload", cust_id);
    },
    editForm: function () {},
    resetForm: function () {
      for (var a in interfaces.customer_asset) {
        if (a === "status") {
          interfaces.customer_asset[a] = "1";
        } else if (a === "reason") {
          this.customerAssetRemoveForm[a] = null;
        } else {
          interfaces.customer_asset[a] = null;
        }
      }
      this.customerAssetForm = interfaces.customer_asset;
    },
    removeForm: function (data) {
      this.resetForm();
      this.$refs.customerAssetRemoveForm.show();
      this.customerAssetRemoveForm = data;
    },
    saveCustomerAsset: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan asset untuk konsumen ini ?")) {
        this.loadingSubmit = true;
        let customer_asset = this.customerAssetForm;
        customer_asset.customer_id = this.customer.id;
        customer_asset.assigned_by = localStorage.getItem("employee_id");
        customer_asset.request_code = this.customer.request_code;
        this.axios
          .post("web/customer/add-customer-asset/", customer_asset)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah asset konsumen",
                message: response.data.message,
              });
            }
            this.cancelCustomerAsset();
          })
          .catch((error) => {
            this.expired(error, "Tambah asset konsumen");
          })
          .finally(() => {
            this.loadingSubmit = false;
            //this.reload(this.customer.id);
            this.reload(this.customer.request_id);
          });
      }
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        this.customers.value = item.item.value;
        this.customers.text = item.item.text;
     }
    },
    focusMe: function(item){
       if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-spkb-piutang/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.demo { 
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
 
input {
  width: 260px;
  padding: 0.5rem;
}
 
.autosuggest__results > ul {
  width: 100%;
  color: rgba(30, 39, 46,1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
}
.autosuggest__results > ul > li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
.autosuggest__results > ul > li:hover {
  cursor: pointer;
}
 
.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}
 
#autosuggest { width: 100%; display: block;}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178,0.2);
}
#autosuggest__input {
      outline: none;
      position: relative;
      display: block;
      font-family: monospace;
      font-size: 20px;
      border: 1px solid #616161;
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    
    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }
    
    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow: scroll;
      max-height: 200px;
    }
    
    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }
    
    .autosuggest__results .autosuggest__results_item {
      cursor: pointer;
      padding: 15px;
    }
    
    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }
    
    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }
    
    .autosuggest__results .autosuggest__results_item:active,
    .autosuggest__results .autosuggest__results_item:hover,
    .autosuggest__results .autosuggest__results_item:focus,
    .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
      background-color: #b6adad;
    }
</style>
